import React from "react";

export const VersaLogo = ({ size = 36, withWordmark = true, dark = false }) => {
  return (
    <div className="flex items-center gap-2.5" data-testid="versacorp-logo">
      <div
        className="relative rounded-xl flex items-center justify-center"
        style={{ width: size, height: size, background: "#0A0A0A" }}
      >
        <svg
          viewBox="0 0 64 64"
          width={size * 0.72}
          height={size * 0.72}
          fill="none"
        >
          <defs>
            <linearGradient id="vc-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#FF1493" />
              <stop offset="50%" stopColor="#FF7A1A" />
              <stop offset="100%" stopColor="#FFC419" />
            </linearGradient>
          </defs>
          <path
            d="M6 8 L58 8 L32 60 Z"
            stroke="url(#vc-grad)"
            strokeWidth="4"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M20 18 L32 44 L44 18"
            stroke="url(#vc-grad)"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      </div>
      {withWordmark && (
        <div className="leading-none">
          <div
            className={`font-display font-extrabold tracking-tight text-[18px] ${
              dark ? "text-white" : "text-neutral-900"
            }`}
          >
            VersaCorp
          </div>
          <div
            className={`font-mono-vc text-[9px] uppercase tracking-[0.22em] mt-0.5 ${
              dark ? "text-neutral-400" : "text-neutral-500"
            }`}
          >
            India Pvt. Ltd.
          </div>
        </div>
      )}
    </div>
  );
};
